var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"progress progresso-top",class:{'hide':_vm.pilha.length == 0}},[_c('div',{staticClass:"indeterminate"})]),_vm._v(" "),_c('div',{staticClass:"overlay",class:{'hide':_vm.pilha.length == 0}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f7ab384","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/topLoader/TopLoader.vue
// module id = 284
// module chunks = 134